import React from 'react'
import Isvg from 'react-inlinesvg'

import iconEmail from '../../sass/icons/icon-email.svg'

import './Newsletter.scss'

const Newsletter = () => {
    return (
        <div className="newsletter-container container">
            <div className="newsletter-form grid">
                <div className="col-6_xs-12 text-container">
                    <div className="icon-container">
                        <Isvg src={iconEmail} />
                    </div>
                    <h4>Seja o primeiro a saber</h4>
                    <p>Assine nossa newsletter e receba conteúdo sobre marketing digital produzido por especialistas</p>
                </div>
                <form action="https://media.us17.list-manage.com/subscribe/post?u=f6bd7113cebdd4c61a0a712a9&amp;id=ae44b8411a" method="post" id="mc-embedded-subscribe-form" name="mc-embedded-subscribe-form" target="_blank" novalidate className="validate form col-6_xs-12">
                    <input type="email" name="EMAIL" placeholder="Digite seu email"/>
                    <button type="submit">Cadastrar</button>

                    <div style={{position: 'absolute', left: '-5000px'}} aria-hidden="true">
                        <input type="text" name="b_f6bd7113cebdd4c61a0a712a9_ae44b8411a" tabIndex="-1" value="" />
                    </div>
                </form>
            </div>
        </div>
    )
}

export default Newsletter


// WEBPACK FOOTER //
// ./src/components/Newsletter/index.js